import React, { Component } from "react";
import ReactMeter from "../common/ReactMeter";

export default class TestScreen extends Component {
  socket = null;

  componentDidMount() {}

  render() {
    return (
      <div>
        <h1 onClick={e => this.sendMessage()}>Hello World</h1>
        <ReactMeter className={"risk-meter"} />
      </div>
    );
  }
}
